<div [hidden]="isDashboardDataLoaded || initializationError" class="spinner-container">
  <div class="d-flex justify-content-center">
    <div class="spinner-border custom-spinner" role="status">
      <span class="visually-hidden">Loading...</span>
    </div>
  </div>
</div>
@if (isUserDetailsLoaded && isDashboardDataLoaded && teamInfoLoaded && !initializationError) {
  <router-outlet></router-outlet>
}

@if (initializationError) {
  <div>
    <iframe src="/assets/errors/500.html" class="iframe-error"></iframe>
  </div>
}
